/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 23.05.2016.
 */

import EPGPage from './epg';

export default EPGPage;



// WEBPACK FOOTER //
// ./src/containers/Epg/index.js